export default "__VITE_ASSET__dQK3Oiwt__"